/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Button, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { useLogin } from '../../hooks/queries/useLogin';
import withBoxStyle from '../../HOC/layout/withBoxStyle';
import { useAppSelector } from '../../redux/hooks';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import PasswordField from '../../components/shared/PasswordField';
import LoginRegistrationHeader from '../../components/layout/LoginRegistrationHeader';

type TUserCredentials = {
  email: string;
  password: string;
};

const LoginForm = withBoxStyle(
  ({
    isValid,
    handleSubmit,
    values,
    disableSubmit,
    handleChange,
    handleBlur,
  }: any) => {
    const navigate = useNavigate();
    return (
      <Box sx={{ p: 3 }} className="d-flex flex-column flex-1">
        <form className="d-flex flex-column flex-1" onSubmit={handleSubmit}>
          <LoginRegistrationHeader />
          <Box pt={5} mb={10}>
            <Typography variant="h4" color="primary" mb={1.5}>
              Password
            </Typography>
            <Typography variant="body1">
              Enter the password you created when booking your appointment
            </Typography>
          </Box>
          <PasswordField
            name="password"
            label="Password"
            value={values.password}
            onBlur={handleBlur}
            onChange={handleChange}
            fullWidth
            sx={{ mb: 2.5 }}
          />
          <Button
            variant="text"
            className="align-self-start"
            onClick={() => {
              navigate('/forgot-password');
            }}
          >
            Forgot password?
          </Button>
          <Box sx={{ pt: 7.5, mt: 'auto', mb: 4.5 }}>
            <Button
              disabled={!isValid || disableSubmit}
              variant="contained"
              color="primary"
              type="submit"
              fullWidth
            >
              Continue
            </Button>
          </Box>
        </form>
      </Box>
    );
  }
);

const LoginComponent = () => {
  const { disableSubmit, sendSignInRequest } = useLogin();
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = location.state || {};
  const authData = useAppSelector((state) => state.auth);
  useEffect(() => {
    if (authData?.accessToken) {
      navigate('/setup/profile', { replace: true });
    }
  }, [authData, navigate]);

  const { handleChange, values, handleSubmit, isValid, handleBlur } = useFormik(
    {
      initialValues: {
        email: email,
        password: '',
      },
      validationSchema: Yup.object({
        password: Yup.string().required('Password is required'),
      }),
      onSubmit: (userCrendentials: TUserCredentials) => {
        sendSignInRequest(userCrendentials);
      },
      validateOnMount: true,
      validateOnChange: true,
    }
  );
  return (
    <>
      <LoginForm
        handleSubmit={handleSubmit}
        isValid={isValid}
        handleBlur={handleBlur}
        handleChange={handleChange}
        values={values}
        disableSubmit={disableSubmit}
      />
    </>
  );
};

export default LoginComponent;
